export default __webpack_public_path__ + "static/media/1853.0b4f1991.png";